/**
 * UpgradeGate.tsx
 * Shown in place of a feature the current tier doesn't include.
 */

import React from 'react';
import { Lock } from 'lucide-react';
import { TIER_LABELS } from '@utils/entitlements';
import type { Tier } from '@db/firebase';

interface UpgradeGateProps {
  feature: string;
  requiredTier: Tier;
}

export default function UpgradeGate({ feature, requiredTier }: UpgradeGateProps): React.ReactElement {
  return (
    <div className="p-6 text-center space-y-3">
      <div className="w-12 h-12 rounded-2xl bg-brand-500/15 border border-brand-500/30 flex items-center justify-center mx-auto">
        <Lock size={20} className="text-brand-500" />
      </div>
      <p className="text-sm font-bold text-slate-900">{feature} is a {TIER_LABELS[requiredTier]} feature</p>
      <p className="text-xs text-slate-500">
        Upgrade your plan in the main app to unlock {feature.toLowerCase()}.
      </p>
    </div>
  );
}
